module.exports = __webpack_public_path__ + "img/next-item.5ada4d60.png";